import { OrderDirection } from '../../../../gen-src/queries/globalTypes';

/**
 * This type represents any "*SortOrder" object generated by the graphql types.
 *
 * Enums are hard to work with in TypeScript (enum values extend their respective string literal type,
 * but are not assignable to other enums that share the same values), so we use string union types
 * to pass the order object around the app.
 *
 * A consequence of this is that when we pass this object into a place expecting the graphql-generated enum version,
 * we must do an explicit type assertion (e.g. `orderBy as TableSortOrder`). However, the compiler does verify that a
 * particular OrderBy type is indeed assignable to its stricter enum counterpart.
 */
export type OrderBy<OrderFields extends string> = {
  readonly field: OrderFields;
  readonly direction: OrderDirection;
};

export function isOrderByEqual(a: OrderBy<string>, b: OrderBy<string>) {
  return a.direction === b.direction && a.field === b.field;
}
